import { useMemo, type ReactNode } from 'react';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { Lang } from '@portal-contract';
import { I18nProvider } from '@/i18n/I18nProvider';
import { createQueryClient } from '@/api/queryClient';
import { SessionProvider } from '@/session/SessionProvider';
import { LoginFlowProvider } from '@/session/LoginFlow';

/**
 * Everything the screens read from context, in dependency order. Must be rendered inside a Router
 * (the session provider navigates on expiry). Tests pass their own QueryClient and language.
 */
export function Providers({ children, queryClient, initialLang }: { children: ReactNode; queryClient?: QueryClient; initialLang?: Lang }) {
  const client = useMemo(() => queryClient ?? createQueryClient(), [queryClient]);
  return (
    <I18nProvider {...(initialLang ? { initialLang } : {})}>
      <QueryClientProvider client={client}>
        <SessionProvider>
          <LoginFlowProvider>{children}</LoginFlowProvider>
        </SessionProvider>
      </QueryClientProvider>
    </I18nProvider>
  );
}
